module.exports = __webpack_public_path__ + "47b6d5f11dc8958c88c6f687cb62a86c.svg";